import * as THREE from "three";
import { getBaseplate } from "./Customisation";
import TexturedMesh from "./TexturedMesh";

/**
 * Creates a flat plane with a texture, with a fixed orientation
 */
export default class BasePlate extends TexturedMesh {
  /**
   * Creates baseplate using the included image
   *
   * @param {Player} player
   * @param {Number} offsetRotation - the offset in radians of the baseplate
   * @param {Number{-1, 1}} rotationDirection - the direction that the rotation should take;
   */
  constructor(player, offsetRotation, flip = true) {
    const geometry = new THREE.PlaneBufferGeometry(110, 110);
    super(player, geometry);

    this.loadTexture(
      {
        urls: {
          full: getBaseplate(),
        },
      },
      flip,
      () => {},
      false,
      false,
    );
    this.material.side = THREE.DoubleSide;
    this.material.transparent = true;
    this.offsetRotation = offsetRotation;
  }

  /**
   * To be called every frame to keep orientation fixed.
   *
   * @param {THREE.Camera} camera
   */
  update(rotation) {
    this.rotation.z = rotation - this.offsetRotation;
  }
}
